import { name, os } from 'platform';
export var getBugReportDestination = function getBugReportDestination(teamProject) {
    var _ref, _ref1;
    var _teamProject_jiraProjects_;
    var supportPortals = (_ref = teamProject === null || teamProject === void 0 ? void 0 : teamProject.contact.supportPortals) !== null && _ref !== void 0 ? _ref : [];
    var jiraProjectKey = (_ref1 = teamProject === null || teamProject === void 0 ? void 0 : (_teamProject_jiraProjects_ = teamProject.jiraProjects[0]) === null || _teamProject_jiraProjects_ === void 0 ? void 0 : _teamProject_jiraProjects_.key) !== null && _ref1 !== void 0 ? _ref1 : null;
    return {
        supportPortals: supportPortals,
        jiraProjectKey: jiraProjectKey,
        jiraProjectUrl: jiraProjectKey ? "https://coveord.atlassian.net/browse/".concat(jiraProjectKey) : null
    };
};
var getBugReportDetailsEnvironment = function getBugReportDetailsEnvironment() {
    return {
        locationHref: typeof window === 'undefined' ? '' : window.location.href,
        viewportWidth: typeof window === 'undefined' ? 0 : window.innerWidth,
        viewportHeight: typeof window === 'undefined' ? 0 : window.innerHeight,
        screenWidth: typeof screen === 'undefined' ? 0 : screen.width,
        screenHeight: typeof screen === 'undefined' ? 0 : screen.height,
        browserName: name !== null && name !== void 0 ? name : 'Unknown',
        operatingSystem: String(os !== null && os !== void 0 ? os : 'Unknown')
    };
};
export var getBugReportDetails = function getBugReportDetails() {
    var environment = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : getBugReportDetailsEnvironment();
    return '<Describe your issue here>\n\n----\n_Issue created using the contextual "Report a problem" button._\nFrom URL: ['.concat(environment.locationHref, "]\nWindow viewport size: *").concat(environment.viewportWidth, "px x ").concat(environment.viewportHeight, "px*\nWindow screen resolution size: *").concat(environment.screenWidth, "px x ").concat(environment.screenHeight, "px*\nBrowser: *").concat(environment.browserName, "*\nOperating System: *").concat(environment.operatingSystem, "*\n");
};

//# sourceMappingURL=BugReportUtils.js.map